import { experienceBuilderApi } from 'api'

export const fetchOnboardingFilters = () =>
  experienceBuilderApi.get<{ data: any[] }>('/marketing-capabilities/onboarding')
